"use strict";
exports.__esModule = true;
exports.extractTokenId = exports.addPrefixToken = void 0;
var addPrefixToken = function (tokenId) { return "algorand/asa/".concat(tokenId); };
exports.addPrefixToken = addPrefixToken;
var extractTokenId = function (tokenId) {
    return tokenId.split("/")[2];
};
exports.extractTokenId = extractTokenId;
//# sourceMappingURL=tokens.js.map